(() => {
    const MOBILE_QUERY = '(max-width: 800px)';
    const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
    const FIRST_CARD_MEDIA_SELECTOR = '#CollectionProductGrid .productListing > .product:first-child .card-media';
    const HINT_DELAY = 2000;
    const HINT_DURATION = 1000;
    const VISIBILITY_THRESHOLD = 0.35;
    let started = false;

    function init() {
        if (started) return;
        started = true;

        if (!document.body?.classList.contains('template-collection')) return;
        if (!window.matchMedia(MOBILE_QUERY).matches) return;
        if (window.matchMedia(REDUCED_MOTION_QUERY).matches) return;

        const media = document.querySelector(FIRST_CARD_MEDIA_SELECTOR);
        if (!media) return;

        let mutationObserver = null;
        let visibilityObserver = null;
        let hintTimer = null;
        let cleanupTimer = null;
        let currentSlide = null;
        let nextSlide = null;
        let cancelled = false;
        let isVisible = false;

        function removeHintClasses() {
            media.classList.remove('is-modab-swipe-hint');
            currentSlide?.classList.remove('modab-swipe-hint-current');
            nextSlide?.classList.remove('modab-swipe-hint-next');
        }

        function cleanup() {
            if (hintTimer) clearTimeout(hintTimer);
            if (cleanupTimer) clearTimeout(cleanupTimer);
            mutationObserver?.disconnect();
            visibilityObserver?.disconnect();
            currentSlide?.removeEventListener('animationend', finishHintAnimation);
            media.removeEventListener('pointerdown', cancelHint);
            removeHintClasses();
        }

        function finishHintAnimation(event) {
            if (event.target !== currentSlide || event.animationName !== 'modabCollectionSwipeHint') return;
            cleanup();
        }

        function cancelHint() {
            cancelled = true;
            cleanup();
        }

        function showHint() {
            hintTimer = null;
            if (
                cancelled
                || !isVisible
                || !media.isConnected
                || !media.classList.contains('slick-initialized')
                || !media.contains(currentSlide)
                || !media.contains(nextSlide)
            ) {
                cleanup();
                return;
            }
            visibilityObserver?.disconnect();
            media.classList.add('is-modab-swipe-hint');
            currentSlide.classList.add('modab-swipe-hint-current');
            nextSlide.classList.add('modab-swipe-hint-next');
            currentSlide.addEventListener('animationend', finishHintAnimation);
            cleanupTimer = setTimeout(cleanup, HINT_DURATION + 100);
        }

        function scheduleHint() {
            if (cancelled || hintTimer) return;
            hintTimer = setTimeout(showHint, HINT_DELAY);
        }

        function cancelPendingHint() {
            if (!hintTimer) return;
            clearTimeout(hintTimer);
            hintTimer = null;
        }

        function observeVisibility() {
            const slides = Array.from(media.querySelectorAll('.slick-slide:not(.slick-cloned)'));

            if (slides.length < 2) {
                cleanup();
                return;
            }

            currentSlide = media.querySelector('.slick-current') || slides[0];
            const currentIndex = slides.indexOf(currentSlide);
            nextSlide = slides[(currentIndex + 1) % slides.length];

            if (
                !currentSlide?.querySelector('img, video')
                || !nextSlide?.querySelector('img, video')
                || nextSlide === currentSlide
            ) {
                cleanup();
                return;
            }

            if (typeof IntersectionObserver !== 'function') {
                isVisible = true;
                scheduleHint();
                return;
            }

            visibilityObserver = new IntersectionObserver(entries => {
                const entry = entries.find(candidate => candidate.target === media);
                if (!entry) return;
                isVisible = entry.isIntersecting && entry.intersectionRatio >= VISIBILITY_THRESHOLD;
                if (isVisible) scheduleHint();
                else cancelPendingHint();
            }, { threshold: VISIBILITY_THRESHOLD });
            visibilityObserver.observe(media);
        }

        function waitForSlick() {
            if (cancelled) return;
            if (media.classList.contains('slick-initialized')) {
                mutationObserver?.disconnect();
                observeVisibility();
                return;
            }

            if (typeof MutationObserver !== 'function' || mutationObserver) return;
            mutationObserver = new MutationObserver(waitForSlick);
            mutationObserver.observe(media, {
                attributes: true,
                attributeFilter: ['class'],
                childList: true,
                subtree: true
            });
        }

        media.addEventListener('pointerdown', cancelHint, { passive: true });
        waitForSlick();
    }

    window.ModabCollectionSwipeHint = { init };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
        init();
    }
})();
